import { glow, spawnFatFish, moveFatFish, drawFatFish } from "@/vessels";

const rand = (a, b) => a + Math.random() * (b - a);
const TINTS = ["330,80%,88%", "265,70%,88%", "200,75%,88%", "40,90%,88%", "0,0%,97%"];

const makeCloud = (w, h, x = rand(-w * 0.2, w)) => {
  const size = rand(110, 240) * Math.max(0.55, Math.min(w, h) / 900);
  const sw = size * 4.2, sh = size * 2.6;
  const sprite = Object.assign(document.createElement("canvas"), { width: Math.ceil(sw), height: Math.ceil(sh) });
  const g = sprite.getContext("2d");
  const tint = TINTS[Math.floor(Math.random() * TINTS.length)];
  for (let i = 0; i < 7; i++) glow(g, sw / 2 + rand(-1.1, 1.1) * size, sh / 2 + rand(-0.3, 0.3) * size, rand(0.45, 0.8) * size, tint, 0.5);
  return { x, y: rand(h * 0.05, h * 0.95), size, vx: rand(0.12, 0.4), ph: rand(0, 6.28), sprite, sw, sh };
};

const sky = (w, h) => {
  const c = document.createElement("canvas");
  c.width = w;
  c.height = h;
  const g = c.getContext("2d");
  const lg = g.createLinearGradient(0, 0, 0, h);
  lg.addColorStop(0, "#2a2360");
  lg.addColorStop(0.55, "#4a3f86");
  lg.addColorStop(1, "#7a5f8f");
  g.fillStyle = lg;
  g.fillRect(0, 0, w, h);
  return c;
};

export const clouds = {
  id: "clouds",
  name: "Heavenly Clouds",
  subtitle: "Soft pastel clouds with fat yellow fish floating through",
  init(w, h) {
    return {
      bg: sky(w, h),
      clouds: Array.from({ length: 9 }, () => makeCloud(w, h)),
      school: Array.from({ length: 4 }, () => {
        const f = spawnFatFish(w, h);
        const q = rand(0.35, 0.7);
        f.x += (w / 2 - f.x) * q;
        f.y += (h / 2 - f.y) * q;
        return f;
      }),
    };
  },
  draw(ctx, w, h, t, s, p, k, fctx = ctx) {
    ctx.globalCompositeOperation = "source-over";
    ctx.drawImage(s.bg, 0, 0);
    const drawCloud = (c, alpha) => {
      ctx.globalAlpha = Math.min(1, alpha * 2);
      ctx.drawImage(c.sprite, c.x - c.sw / 2, c.y - c.sh / 2 + Math.sin(t * 0.3 + c.ph) * 6);
      ctx.globalAlpha = 1;
    };
    s.clouds.forEach((c, i) => {
      c.x += c.vx * k;
      if (c.x - c.size * 2 > w) s.clouds[i] = makeCloud(w, h, -c.size * 2);
      if (i % 2 === 0) drawCloud(c, 0.28 + p * 0.1);
    });
    const fl = s.fishLayer || (s.fishLayer = Object.assign(document.createElement("canvas"), { width: w, height: h }));
    const fx = fl.getContext("2d");
    fx.clearRect(0, 0, w, h);
    s.school = s.school.map((f) => (moveFatFish(f, w, h, t, k * 0.7) ? f : spawnFatFish(w, h)));
    s.school.forEach((f) => drawFatFish(fx, f, t, 0.5 + p * 0.1));
    fctx.globalCompositeOperation = "source-over";
    fctx.drawImage(fl, 0, 0);
    s.clouds.forEach((c, i) => i % 2 && drawCloud(c, 0.22 + p * 0.1));
  },
};
